import JSEncrypt from 'jsencrypt';

export const encryptData = (data, app) => {
    try {

        const encrypt = new JSEncrypt({
            default_key_size: 2048
        });

        encrypt.setPublicKey(app.kp);
        
        const jsonString = JSON.stringify(data);
        
        const encrypted = encrypt.encrypt(jsonString);
        
        if (!encrypted) {
            console.error('Error en el cifrado:', encrypt.getError());
            throw new Error('Error en el cifrado');
        }
        
        return encrypted;
    } catch (error) {
        console.error('Error al cifrar:', error);
        throw error;
    }
};

export const encryptCode = (data, app) => {
    try {

        const encrypt = new JSEncrypt({
            default_key_size: 2048
        });

        encrypt.setPublicKey(app.kp);
        
        const jsonString = JSON.stringify(data);
        
        const encrypted = encrypt.encrypt(jsonString);
        
        if (!encrypted) {
            console.error('Error en el cifrado:', encrypt.getError());
            throw new Error('Error en el cifrado');
        }
        
        return encrypted.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
    } catch (error) {
        console.error('Error al cifrar:', error);
        throw error;
    }
};
